import { Outlet } from "react-router";
import Header from "../../layouts/Header";

const Root = () => {
  return (
    <section>
      <Header Sign_log="none" isStatic={false} />
      <Outlet />
    </section>
  );
};
export default Root;
